import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Switch,
  message,
  Descriptions,
} from "antd";

const ChallengeDetail = ({
  visible,
  onClose,
  challenge,
  onDelete,
  onUpdate,
}) => {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();

  if (!challenge) return null;

  const handleEdit = () => {
    setEditing(true);
    form.setFieldsValue({ ...challenge });
  };

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      const updatedData = { ...values, id: challenge.id };
      onUpdate(updatedData);
      setEditing(false);
    } catch (error) {
      message.error("수정에 실패했습니다.");
    }
  };

  return (
    <Modal
      title="챌린지 상세 정보"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {!editing ? (
        <>
          <Descriptions bordered>
            <Descriptions.Item label="챌린지 제목">
              {challenge.challenge_title}
            </Descriptions.Item>
            <Descriptions.Item label="인증방식">
              {challenge.challenge_certification}
            </Descriptions.Item>
            <Descriptions.Item label="인증 빈도">
              {challenge.challenge_frequency}
            </Descriptions.Item>
            <Descriptions.Item label="일일 인증 횟수">
              {challenge.challenge_daily}
            </Descriptions.Item>
            <Descriptions.Item label="참여 인원">
              {challenge.challenge_participation}
            </Descriptions.Item>
            <Descriptions.Item label="최대 참여">
              {challenge.challenge_max}
            </Descriptions.Item>
            <Descriptions.Item label="최대 인증 횟수">
              {challenge.challenge_auth_cnt}
            </Descriptions.Item>
            <Descriptions.Item label="챌린지 아이콘">
              {challenge.challenge_icon}
            </Descriptions.Item>
            <Descriptions.Item label="인증 설명">
              {challenge.challenge_auth_description}
            </Descriptions.Item>
            <Descriptions.Item label="챌린지 설명">
              {challenge.challenge_description}
            </Descriptions.Item>
            <Descriptions.Item label="시작일">
              {challenge.challenge_start}
            </Descriptions.Item>
            <Descriptions.Item label="종료일">
              {challenge.challenge_end}
            </Descriptions.Item>
            <Descriptions.Item label="공개 여부">
              {challenge.is_private ? "비공개" : "공개"}
            </Descriptions.Item>
            <Descriptions.Item label="주 인증 최대 횟수">
              {challenge.challenge_weekly_auth}
            </Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              type="primary"
              onClick={handleEdit}
              style={{ marginRight: 8 }}
            >
              수정
            </Button>
            <Button type="danger" onClick={() => onDelete(challenge.id)}>
              삭제
            </Button>
            <Button onClick={onClose}>닫기</Button>
          </div>
        </>
      ) : (
        <Form form={form} layout="vertical">
          <Form.Item
            name="challenge_title"
            label="챌린지 제목"
            rules={[{ required: true, message: "챌린지 제목을 입력해주세요." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="challenge_certification"
            label="인증방식"
            rules={[{ required: true, message: "인증 방식을 입력해주세요." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="challenge_frequency" label="인증 빈도">
            <Input />
          </Form.Item>
          <Form.Item name="challenge_daily" label="일일 인증 횟수">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="challenge_participation" label="참여 인원">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="challenge_max" label="최대 참여">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="challenge_auth_cnt" label="최대 인증 횟수">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="challenge_icon" label="챌린지 아이콘 (숫자 입력)">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="challenge_auth_description" label="인증 설명">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item name="challenge_description" label="챌린지 설명">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item
            name="challenge_start"
            label="시작일 (YYYY-MM-DD)"
            rules={[{ required: true, message: "시작일을 입력해주세요." }]}
          >
            <Input placeholder="예: 2024-01-01" />
          </Form.Item>
          <Form.Item
            name="challenge_end"
            label="종료일 (YYYY-MM-DD)"
            rules={[{ required: true, message: "종료일을 입력해주세요." }]}
          >
            <Input placeholder="예: 2024-12-31" />
          </Form.Item>
          <Form.Item name="is_private" label="비공개" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item name="challenge_weekly_auth" label="주 인증 최대 횟수">
            <Input type="text" />
          </Form.Item>
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <Button
              type="primary"
              onClick={handleUpdate}
              style={{ marginRight: 8 }}
            >
              저장
            </Button>
            <Button onClick={() => setEditing(false)}>취소</Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default ChallengeDetail;
